// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"MobileHotelDetails_listContainer__rlXQF","psaBanner":"MobileHotelDetails_psaBanner__BBtqS","poolHours":"MobileHotelDetails_poolHours__gV8Px"};